var installedModules = {};
var moduleToHandlerMapping = {
	76652: {
		getter: () => (() => (__webpack_require__(87835))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@openshift/dynamic-plugin-sdk",
	},
	84831: {
		getter: () => (() => (__webpack_require__(63696))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	58343: {
		getter: () => (() => (__webpack_require__(78325))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	91757: {
		getter: () => (() => (__webpack_require__(79227))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.17.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	},
	31645: {
		getter: () => (() => (__webpack_require__(65464))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.17.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	99390: {
		getter: () => (Promise.all([__webpack_require__.e(6384), __webpack_require__.e(1004), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(40283))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "*",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@odh-dashboard/k8s-core",
	},
	25644: {
		getter: () => (() => (__webpack_require__(5405))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.4.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@patternfly/react-icons",
	},
	79248: {
		getter: () => (Promise.all([__webpack_require__.e(6733), __webpack_require__.e(5), __webpack_require__.e(262), __webpack_require__.e(7505), __webpack_require__.e(6727)]).then(() => (() => (__webpack_require__(6727))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.4.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@patternfly/react-core",
	},
	66238: {
		getter: () => (Promise.all([__webpack_require__.e(6384), __webpack_require__.e(8212), __webpack_require__.e(6288), __webpack_require__.e(1645), __webpack_require__.e(8350)]).then(() => (() => (__webpack_require__(85969))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "*",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@odh-dashboard/plugin-core",
	},
	11004: {
		getter: () => (__webpack_require__.e(4951).then(() => (() => (__webpack_require__(34951))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "*",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@odh-dashboard/foundation",
	},
	9728: {
		getter: () => (() => (__webpack_require__(3791))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@openshift/dynamic-plugin-sdk-utils",
	},
	28142: {
		getter: () => (__webpack_require__.e(6097).then(() => (() => (__webpack_require__(86097))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "*",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@odh-dashboard/ui-core",
	},
	20450: {
		getter: () => (__webpack_require__.e(8957).then(() => (() => (__webpack_require__(91338))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "*",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@odh-dashboard/connection-types",
	},
	51448: {
		getter: () => (Promise.all([__webpack_require__.e(6733), __webpack_require__.e(3449), __webpack_require__.e(6207)]).then(() => (() => (__webpack_require__(76207))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.4.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@patternfly/react-code-editor",
	},
	8349: {
		getter: () => (__webpack_require__.e(5184).then(() => (() => (__webpack_require__(35184))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.44.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	},
	83956: {
		getter: () => (__webpack_require__.e(5975).then(() => (() => (__webpack_require__(85975))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.2.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "use-query-params",
	}
};
var initialConsumes = [76652,84831,58343,91757];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"450": [
		20450
	],
	"519": [
		25644,
		79248
	],
	"1004": [
		11004
	],
	"1448": [
		51448
	],
	"1645": [
		31645
	],
	"3524": [
		76652,
		84831,
		58343,
		91757
	],
	"3987": [
		8349,
		83956
	],
	"5104": [
		9728,
		28142
	],
	"6238": [
		66238
	],
	"9390": [
		99390
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}